<template>
  <router-view />
</template>

<script>
export default {
  name: 'PermPlacements'
};
</script>

<style lang="scss" scoped></style>
